(function() {
  const container = document.createElement('div');
  container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1000;overflow:hidden;';
  document.body.appendChild(container);
  // Position de la souris
  let mouseX = -1000;
  let mouseY = -1000;
  const MOUSE_RADIUS = 80; // zone d'effet
  const MOUSE_FORCE = 3;   // force de répulsion

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  // Quand la souris quitte la fenêtre
  document.addEventListener('mouseleave', () => {
    mouseX = -1000;
    mouseY = -1000;
  });

  const snowflakes = [];
  const MAX_FLAKES = 60;

  // Plusieurs designs de flocons pour plus de variété
  const flakeDesigns = [
    // Design 1 - Classique 6 branches
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="2">
        <circle cx="50" cy="50" r="4" fill="white"/>
        <path d="M50 10 L50 90 M10 50 L90 50"/>
        <path d="M22 22 L78 78 M78 22 L22 78"/>
        <path d="M50 10 L45 25 M50 10 L55 25"/>
        <path d="M50 90 L45 75 M50 90 L55 75"/>
        <path d="M10 50 L25 45 M10 50 L25 55"/>
        <path d="M90 50 L75 45 M90 50 L75 55"/>
        <path d="M22 22 L35 35 M78 78 L65 65"/>
        <path d="M78 22 L65 35 M22 78 L35 65"/>
        <path d="M50 35 L45 40 L50 45 L55 40 L50 35"/>
        <path d="M50 55 L45 60 L50 65 L55 60 L50 55"/>
        <path d="M35 50 L40 45 L45 50 L40 55 L35 50"/>
        <path d="M55 50 L60 45 L65 50 L60 55 L55 50"/>
      </g>
    </svg>`,
    // Design 2 - Étoile simple
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="1.5">
        <circle cx="50" cy="50" r="3" fill="white"/>
        <path d="M50 8 L50 92 M8 50 L92 50"/>
        <path d="M20 20 L80 80 M80 20 L20 80"/>
        <path d="M50 8 L43 22 M50 8 L57 22"/>
        <path d="M50 92 L43 78 M50 92 L57 78"/>
        <path d="M8 50 L22 43 M8 50 L22 57"/>
        <path d="M92 50 L78 43 M92 50 L78 57"/>
        <path d="M50 30 L44 36 M50 30 L56 36"/>
        <path d="M50 70 L44 64 M50 70 L56 64"/>
        <path d="M30 50 L36 44 M30 50 L36 56"/>
        <path d="M70 50 L64 44 M70 50 L64 56"/>
        <path d="M28 28 L36 32 M72 72 L64 68"/>
        <path d="M72 28 L64 32 M28 72 L36 68"/>
      </g>
    </svg>`,
    // Design 3 - Cristal détaillé
 `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="none" stroke="rgba(255,255,255,0.85)" stroke-width="2">
        <circle cx="50" cy="50" r="5" fill="white"/>
        <path d="M50 5 L50 95 M5 50 L95 50"/>
        <path d="M18 18 L82 82 M82 18 L18 82"/>
        <path d="M50 5 L44 18 M50 5 L56 18"/>
        <path d="M50 95 L44 82 M50 95 L56 82"/>
        <path d="M5 50 L18 44 M5 50 L18 56"/>
        <path d="M95 50 L82 44 M95 50 L82 56"/>
        <path d="M50 28 L46 34 L50 40 L54 34 Z"/>
        <path d="M50 60 L46 66 L50 72 L54 66 Z"/>
        <path d="M28 50 L34 46 L40 50 L34 54 Z"/>
        <path d="M60 50 L66 46 L72 50 L66 54 Z"/>
        <path d="M18 18 L30 26 M82 82 L70 74"/>
        <path d="M82 18 L70 26 M18 82 L30 74"/>
      </g>
    </svg>`,
    // Design 4 - Petit point (neige fine)
    `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="8" fill="currentColor"/></svg>`
  ];

  function createSnowflake() {
    // Profondeur (0 = loin/petit, 1 = proche/grand)
    const depth = Math.random();
    const size = 5 + depth * 18;
    
    const flake = {
      x: Math.random() * window.innerWidth,
      y: -size,
      size,
      depth,
      // Vitesse basée sur la profondeur (plus proche = plus rapide)
      baseSpeed: 0.3 + depth * 1.2,
      speed: 0,
      // Paramètres de mouvement latéral
      wobbleAmplitude: 20 + Math.random() * 40,
      wobbleFrequency: 0.5 + Math.random() * 1.5,
      wobbleOffset: Math.random() * Math.PI * 2,
      // Rotation
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 2,
      // Turbulence
      turbulenceX: 0,
      turbulenceY: 0,
      // Scintillement
      baseOpacity: 0.2 + depth * 0.4,
      opacity: 1
    };

    const wrapper = document.createElement('div');
    const designIndex = depth < 0.3 ? 3 : Math.floor(Math.random() * 3);
    
    wrapper.innerHTML = flakeDesigns[designIndex];
    wrapper.style.cssText = `
      position: absolute;
      width: ${size}px;
      height: ${size}px;
      color: rgba(255, 255, 255, ${flake.baseOpacity});
      will-change: transform, opacity;
      filter: blur(${(1 - depth) * 1}px);
    `;
    
    flake.element = wrapper;
    container.appendChild(wrapper);
    snowflakes.push(flake);
  }

  let lastTime = performance.now();
  let globalTime = 0;
  let spawnCounter = 0;

  function animate(currentTime) {
    const deltaTime = Math.min((currentTime - lastTime) / 16.67, 3);
    lastTime = currentTime;
    globalTime += deltaTime * 0.02;

    for (let i = snowflakes.length - 1; i >= 0; i--) {
      const flake = snowflakes[i];
      
      // Accélération progressive (simulation de gravité légère)
      flake.speed = flake.baseSpeed + Math.sin(globalTime * 0.5) * 0.2;
      
      // Mouvement vertical
      flake.y += flake.speed * deltaTime;
      
      // Mouvement latéral sinusoïdal naturel
      const wobble = Math.sin(globalTime * flake.wobbleFrequency + flake.wobbleOffset);
      flake.x += wobble * flake.wobbleAmplitude * 0.02 * deltaTime;
      
      // Turbulence aléatoire subtile
      flake.turbulenceX += (Math.random() - 0.5) * 0.3;
      flake.turbulenceY += (Math.random() - 0.5) * 0.1;
      flake.turbulenceX *= 0.95;
      flake.turbulenceY *= 0.95;
      flake.x += flake.turbulenceX * deltaTime;
      flake.y += flake.turbulenceY * deltaTime;
      
      // Répulsion souris
      const dx = flake.x - mouseX;
      const dy = flake.y - mouseY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < MOUSE_RADIUS && distance > 0) {
        const force = (MOUSE_RADIUS - distance) / MOUSE_RADIUS * MOUSE_FORCE;
        flake.x += (dx / distance) * force * deltaTime;
        flake.y += (dy / distance) * force * deltaTime;
      }

      // Rotation
      flake.rotation += flake.rotationSpeed * deltaTime;
      
      // Scintillement subtil
      flake.opacity = flake.baseOpacity + Math.sin(globalTime * 3 + i) * 0.1;

      // Application des transformations
      flake.element.style.transform = 
        `translate3d(${flake.x}px, ${flake.y}px, 0) rotate(${flake.rotation}deg)`;
      flake.element.style.opacity = flake.opacity;

      // Suppression si hors écran
      if (flake.y > window.innerHeight + flake.size || 
          flake.x < -flake.size || 
          flake.x > window.innerWidth + flake.size) {
        container.removeChild(flake.element);
        snowflakes.splice(i, 1);
      }
    }
  spawnCounter++;
  if (snowflakes.length < MAX_FLAKES && spawnCounter % 10 === 0) {
    createSnowflake();
  }

  requestAnimationFrame(animate);
}

  // Démarrage avec quelques flocons
  for (let i = 0; i < 5; i++) {
    setTimeout(() => createSnowflake(), i * 80);
  }

  requestAnimationFrame(animate);
})();